export const DEFAULT_API_URL = "https://api.tonightpass.com";
